import { ScheduleSpeakingClassesEvent } from "@/types";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import SuccessIcon from "../icons/SuccessIcon";
import dayjs from "dayjs";
import { INTERNAL_DATE_FORMAT } from "@/utils/agenda";
import routes from "@/config/routes.ts";
import Button from "@edusogno/primitives/button.js";

interface SuccessMessageProps {
  events: ScheduleSpeakingClassesEvent[] | null;
  onClose?: () => void;
}

const SpeakingSuccessMessage: React.FC<SuccessMessageProps> = ({
  events,
  onClose,
}) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <div className=" !flex flex-col py-8 px-12 bg-white pt-12 justify-evenly h-full flex-[1_1_100%] gap-6">
      <div className="flex flex-row  gap-4 items-center">
        <SuccessIcon width={60} height={60} />
        <p className="text-secondary text-2xl font-semibold">
          All good, events has been successfully scheduled!
        </p>
      </div>
      {events?.length === 1 ? (
        <p className="[&_i]:not-italic [&_i]:font-semibold [&_i]:text-secondary">
          Your Speaking class with topic&nbsp;
          <i>{events[0]?.topic}</i>&nbsp;on the{" "}
          <i>
            {dayjs(events[0]?.data, INTERNAL_DATE_FORMAT)
              .format("ddd DD MMM")
              .toUpperCase()}
            , {events[0]?.ora} - {events[0]?.oraFine}
          </i>
          &nbsp;with <i>{events[0]?.tutors?.first_name}</i>&nbsp;has been
          successfully scheduled! An event was created on your Agenda
        </p>
      ) : (
        <div className="[&_i]:not-italic [&_i]:font-semibold [&_i]:text-secondary">
          <p>Your Speaking classes with topics</p>
          <ul className="list-disc pl-4">
            {events?.map((item) => (
              <li key={`li_${item?.id}`}>
                <i>{item?.topic}</i>&nbsp;on the{" "}
                <i>
                  {dayjs(item?.data, INTERNAL_DATE_FORMAT)
                    .format("ddd DD MMM")
                    .toUpperCase()}
                  , {item?.ora} - {item?.oraFine}
                </i>
                &nbsp;with <i>{item?.tutors?.first_name}</i>&nbsp;
              </li>
            ))}
          </ul>
          have been successfully scheduled! The events were created on your
          Agenda
        </div>
      )}
      <Button
        className="mx-auto mt-auto"
        onClick={() => {
          if (onClose) {
            onClose();
          } else {
            navigate(routes.agenda);
          }
        }}
        size="md"
      >
        {t("btns.go_to_agenda")}
      </Button>
    </div>
  );
};

export default SpeakingSuccessMessage;
